export default __webpack_public_path__ + "static/media/wallet.9e5e664f.svg";